import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { Error404PageComponent } from './errors/containers/error-404-page/error-404-page.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/performances',
    pathMatch: 'full'
  },
  {
    path: 'tests',
    loadChildren: () => import('./tests/tests.module').then(m => m.TestsModule)
  },
  {
    path: 'offers',
    loadChildren: () => import('./offers/offers.module').then(m => m.OffersModule)
  },
  {
    path: 'coupons',
    loadChildren: () => import('./coupons/coupons.module').then(m => m.CouponsModule)
  },
  {
    path: 'campaigns',
    loadChildren: () => import('./campaigns/campaigns.module').then(m => m.CampaignsModule)
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
  },
  {
    path: 'consumers',
    loadChildren: () => import('./consumers/consumers.module').then(m => m.ConsumersModule)
  },
  // {
  //   path: 'consumer-events',
  //   loadChildren: () => import('./consumer-events/consumer-events.module').then(m => m.ConsumerEventsModule)
  // },
  {
    path: 'gifts',
    data: {
      type: 'gifts'
    },
    loadChildren: () => import('./rewards/rewards.module').then(m => m.RewardsModule)
  },
  {
    path: 'rewards',
    data: {
      type: 'cashbacks'
    },
    loadChildren: () => import('./rewards/rewards.module').then(m => m.RewardsModule)
  },
  {
    path: 'invoices',
    loadChildren: () => import('./invoices/invoices.module').then(m => m.InvoicesModule)
  },
  {
    path: 'performances',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'developers',
    redirectTo: '/developers/logs',
    pathMatch: 'full'
  },
  {
    path: 'developers',
    loadChildren: () => import('./technicals/technicals.module').then(m => m.TechnicalsModule)
  },
  {
    path: 'account',
    redirectTo: '/account/settings',
    pathMatch: 'full'
  },
  {
    path: 'account/segments',
    loadChildren: () => import('./segments/segments.module').then(m => m.SegmentsModule)
  },
  {
    path: 'account/users',
    loadChildren: () => import('./users/users.module').then(m => m.UsersModule)
  },
  {
    path: 'account/ventilations',
    loadChildren: () => import('./ventilations/ventilations.module').then(m => m.VentilationsModule)
  },
  {
    path: 'account/programs',
    loadChildren: () => import('./programs/programs.module').then(m => m.ProgramsModule)
  },
  {
    path: 'account/settings',
    loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: 'account/brands',
    loadChildren: () => import('./brands/brands.module').then(m => m.BrandsModule)
  },
  {
    path: '404',
    loadChildren: () => import('./errors/errors.module').then(m => m.ErrorsModule)
  },
  {
    path: '**',
    redirectTo: '404',
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
